import { render, staticRenderFns } from "./verPicking.vue?vue&type=template&id=1c37aadc"
import script from "./verPicking.vue?vue&type=script&lang=js"
export * from "./verPicking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports